import { useEffect, useState } from 'react';
import { usersApi } from '../api/endpoints';

// Real CRM users (Active only) for owner/agent/coordinator dropdowns
export const useTeamOptions = () => {
  const [team, setTeam] = useState([]);
  useEffect(() => {
    usersApi.options()
      .then(setTeam)
      .catch(e => console.error('Failed to load team members', e));
  }, []);
  return team;
};

export default useTeamOptions;
